<template>
  <section class="login-section">
    <div class="login-container">
      <div class="login-header">
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.464" width="24" height="24" rx="4.8" fill="#1890FF" />
          <path d="M14.864 3.6H20.864V9.6H14.864V3.6Z" fill="white" />
          <path d="M10.064 9.6H14.864V14.4H10.064V9.6Z" fill="white" />
          <path d="M4.064 13.2H11.264V20.4H4.064V13.2Z" fill="white" />
        </svg>
        <a-typography-title class="login-title" :level="2">Login</a-typography-title>
        <a-typography-text class="login-text">
          Welcome back! Please enter your information to login
        </a-typography-text>
      </div>

      <div v-if="isInProcess" class="login-loading">
        <LoadingSpinner color="#1890FF" />
      </div>

      <div v-if="isWarning" class="login-warning">
        {{ message }}
      </div>

      <a-form layout="vertical" :model="form" @finish="login">
        <a-form-item
          label="メールアドレス"
          name="email"
          :rules="[{ required: true, type: 'email', message: 'Please enter your email!' }]"
        >
          <a-input v-model:value="form.email" placeholder="Email">
            <template #prefix><MailOutlined /></template>
          </a-input>
        </a-form-item>

        <a-form-item
          label="パスワード"
          name="password"
          :rules="[{ required: true, message: 'Please enter your password!' }]"
        >
          <a-input-password v-model:value="form.password" placeholder="Password">
            <template #prefix><LockOutlined /></template>
          </a-input-password>
        </a-form-item>

        <a-form-item>
          <a-button block type="primary" html-type="submit" :loading="isInProcess">Login</a-button>
        </a-form-item>
      </a-form>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { MailOutlined, LockOutlined } from '@ant-design/icons-vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import { Auth } from '@/lib/auth';
import Cookies from 'js-cookie';

const form = ref({
  email: '',
  password: '',
});

const isInProcess = ref(false);
const isWarning = ref(false);
const message = ref('');
const router = useRouter();

const login = async () => {
  isInProcess.value = true;
  isWarning.value = false;
  message.value = '';

  try {
    const result = await Auth.login({
      email: form.value.email,
      password: form.value.password,
    })
    if (result.accessToken) {
      Cookies.set('accessToken', result.accessToken)
      router.push('/');
    } else {
      isWarning.value = true;
      message.value = result.error || 'Login failed.';
    }

  } catch (err: any) {
    isWarning.value = true;
    console.log('Login error:', err.response);

    if (err.response && err.response.data && err.response.data.error) {
      message.value = err.response.data.error;
    } else if (err.message) {
      message.value = err.message;
    } else {
      message.value = 'メールアドレスとパスワードは必須です。';
    }
  } finally {
    isInProcess.value = false;
  }
};

</script>

<style lang="scss" scoped>
@use './styles/login' as *;
</style>
